export default __webpack_public_path__ + "static/media/Nina_Oil_Painting.2bd0f153.jpg";